// extracted by mini-css-extract-plugin
export default {"space":"pricing_space__DjpZf","pricing__section":"pricing_pricing__section__003EI"};